import { cva } from 'class-variance-authority'

export const emptyVariants = cva(
  'flex w-full flex-col items-center justify-center gap-stack rounded-20 px-80 text-center',
  {
    variants: {
      variant: {
        base: '',
        neutral: 'bg-surface-neutral-inverse',
        body: 'max-w-[720px]',
      },
      size: {
        compact: 'py-60',
        large: 'py-100',
      },
    },
    defaultVariants: { variant: 'base', size: 'compact' },
  },
)
